import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode, VolunteerStatusId } from '@interfaces';
import { VolunteerTopicsFormDialog, VolunteerTopicsFormDialogData } from '../../..';
import { VolunteerDialogDataService } from '../../volunteer-dialog-data.service';



export function getButtons(dialogDataService: VolunteerDialogDataService, dialogService: DialogService) {

	const buttons: GridButton[] = [];

	const addButton = {
		iconClass: 'fa-plus',
		label: 'Add Volunteer Topic',
		execute: async () => {
			const volunteerDetails = dialogDataService.volunteerDetails();
			if (!volunteerDetails) {
				dialogService.showMessage('Message', 'Volunteer details not found.', 'Okay', [], 400, 200);
				return;
			}

			const volunteerId = volunteerDetails.volunteerId;
			const statusId = volunteerDetails.volunteerStatusId;
			if (statusId === VolunteerStatusId.Approved || statusId === VolunteerStatusId.ApprovedWithCaution) {
				await dialogService.showCustom<VolunteerTopicsFormDialog, VolunteerTopicsFormDialogData>(VolunteerTopicsFormDialog, {
					data: {
						mode: DialogMode.ADD,
						volunteerId,
						volunteerTopicId: undefined,
						readonly: !dialogDataService.hasVolunteerEditPermissions(),
					}
				}, 500, 450);
				await dialogDataService.getVolunteerDetails(volunteerId);

			}
			else {
				dialogService.showMessage('Message', 'Volunteer topic can only be added for approved volunteers.', 'Okay', [], 400, 200);
				return;
			}
		},
	};

	if (dialogDataService.hasVolunteerEditPermissions()) {
		buttons.push(addButton);
	}

	buttons.push(
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => {
				const volunteerId = dialogDataService.volunteerDetails()?.volunteerId;
				dialogDataService.getVolunteerDetails(volunteerId!);
			}
		},
	);

	return buttons;
}